import { type UseFormReturn, useForm } from '@fukuri-admins/hooks/common';
import { useToast } from '@fukuri-admins/ui/common/Toast/hooks';
import { getThreeLetterCode } from '@fukuri-admins/utils/common/cookies';
import { zodResolver } from '@hookform/resolvers/zod';
import {
  CreateClientAdminUserFormFieldValues,
  createClientAdminUserSchema,
} from '../logics/schema';
import { useCreateClientAdminUser } from './useCreateClientAdminUser';

type Args = {
  handleMutateUsers: () => void;
};
type IUseCreateClientAdminUserModal = (args: Args) => {
  state: {
    methods: UseFormReturn<CreateClientAdminUserFormFieldValues>;
  };
  actions: {
    handleSubmit: () => void;
  };
};

export const useCreateClientAdminUserModal: IUseCreateClientAdminUserModal = ({
  handleMutateUsers,
}) => {
  const { showToast } = useToast();
  const methods = useForm<CreateClientAdminUserFormFieldValues>({
    defaultValues: {
      fullName: '',
      email: '',
    },
    criteriaMode: 'all',
    mode: 'onChange',
    resolver: zodResolver(createClientAdminUserSchema),
  });

  const threeLetterCode = getThreeLetterCode() || '';

  const { trigger } = useCreateClientAdminUser(threeLetterCode, {
    swr: {
      onSuccess: () => {
        showToast({
          message: '管理者を追加しました。',
          status: 'success',
        });
        handleMutateUsers();
      },
      onError: () => {
        showToast({
          message: '管理者の追加に失敗しました。',
          status: 'danger',
        });
      },
    },
  });

  const handleSubmit = methods.handleSubmit(async data => {
    await trigger({
      client_admin_user: {
        full_name: data.fullName,
        email: data.email,
      },
    });
  });

  return {
    state: {
      methods,
    },
    actions: {
      handleSubmit,
    },
  };
};
